<template>
    <div class="col-xs-12 col-sm-6">
        <div class="grid-container m-0 m-t-20" v-pml-block="isSaving">
            <p><strong>{{ $t('name') }}: </strong>{{ item.name }}</p>
            <p><strong>{{ $t('fancy_name') }}: </strong>{{ item.fancy_name }}</p>
            <p><strong>{{ $t('iso') }}: </strong>{{ item.iso }}</p>
            <div class="row">
                <div class="col-sm-6">
                    <label class="input-group">
                        <span class="input-group-addon">{{ item.symbol }}</span>
                        <input class="form-control t_right" type="text" disabled value="1,00">
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="input-group">
                        <span class="input-group-addon">{{ tenant.currency_id | pmlCurrencyById('symbol') }}</span>
                        <pml-numeric v-model="beautValue" @blur="saveHuman()" :precision="6"></pml-numeric>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update } from 'services/exchange-rate'
    import { mapGetters } from 'vuex'
    import { round } from 'lodash'

    export default {
        name: 'ExchangeRateItem',
        props: [ 'item' ],
        data () {
            return {
                base: '1,0',
                current: null,
                currentHuman: null,
                isSaving: false,
                beautValue: null
            }
        },
        mounted () {
            this.current = this.item.pivot.exchange_rate
            this.valueBeautify()
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            })
        },
        watch: {
            item () {
                this.valueBeautify()
            }
        },
        methods: {
            valueBeautify () {
                this.beautValue = round(1 / this.item.pivot.exchange_rate, 6)
                this.currentHuman = this.beautValue
            },
            saveHuman () {
                if (this.currentHuman === this.beautValue) return

                this.isSaving = true

                this.item.pivot.exchange_rate = 1 / this.beautValue

                update({ item: this.item, rate: this.item.pivot.exchange_rate })
                    .then(() => { this.current = this.item.pivot.exchange_rate })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSaving = false })
            },
            saveRate () {
                if (this.current === this.item.pivot.exchange_rate) return

                this.isSaving = true

                update({ item: this.item, rate: this.item.pivot.exchange_rate })
                    .then(() => { this.current = this.item.pivot.exchange_rate })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/exchange_rate/components/Item.vue